export enum CS_EVENT_NATURE {
	ACK = 'ACK',
	REQUEST = 'REQUEST',
	RESPONSE = 'RESPONSE',
}
